module.exports = __webpack_public_path__ + "img/39.e7ccb706.png";